import { Icon, IconProps } from '@chakra-ui/react';

export const UnclaimedApartment = (props: IconProps) => {
  return (
    <Icon
      width="151"
      height="92"
      viewBox="0 0 151 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M18.2474 92L17.9883 91.9417C20.8776 79.0995 28.1386 67.4376 38.4339 59.1042C46.2174 52.8137 55.4747 48.6066 65.3342 46.879C75.1936 45.1514 85.3308 45.9601 94.7912 49.2291C104.252 52.4981 112.724 58.1197 119.41 65.5646C126.097 73.0096 130.778 82.0329 133.012 91.785L132.753 91.8438C126.637 65.0037 103.101 46.2581 75.5179 46.2581C48.2963 46.2581 24.2106 65.4953 18.2474 92Z"
          fill="#3F3D56"
        />
        <path
          d="M55.3974 16.4217C59.3813 16.4217 62.6108 13.1939 62.6108 9.21219C62.6108 5.23049 59.3813 2.00269 55.3974 2.00269C51.4136 2.00269 48.1841 5.23049 48.1841 9.21219C48.1841 13.1939 51.4136 16.4217 55.3974 16.4217Z"
          fill="#FF6584"
        />
        <path
          d="M24.3209 90.3622C24.5458 91.1934 25.3164 91.7082 25.3164 91.7082C25.3164 91.7082 25.7222 90.8753 25.4972 90.0442C25.2723 89.213 24.5017 88.6982 24.5017 88.6982C24.5017 88.6982 24.0959 89.5311 24.3209 90.3622Z"
          fill="#3F3D56"
        />
        <path
          d="M24.6512 90.1836C25.2685 90.7842 25.3439 91.7074 25.3439 91.7074C25.3439 91.7074 24.4184 91.6569 23.8011 91.0563C23.1838 90.4557 23.1084 89.5325 23.1084 89.5325C23.1084 89.5325 24.0339 89.583 24.6512 90.1836Z"
          fill="#04C2A0"
        />
        <path
          d="M41.4527 90.3622C41.6777 91.1934 42.4482 91.7082 42.4482 91.7082C42.4482 91.7082 42.8541 90.8753 42.6291 90.0442C42.4041 89.213 41.6336 88.6982 41.6336 88.6982C41.6336 88.6982 41.2277 89.5311 41.4527 90.3622Z"
          fill="#3F3D56"
        />
        <path
          d="M41.783 90.1836C42.4003 90.7842 42.4757 91.7074 42.4757 91.7074C42.4757 91.7074 41.5503 91.6569 40.9329 91.0563C40.3156 90.4557 40.2402 89.5325 40.2402 89.5325C40.2402 89.5325 41.1657 89.583 41.783 90.1836Z"
          fill="#04C2A0"
        />
        <path
          d="M44.8501 24.1562L42.1377 21.9874L57.3272 8.43262H95.8433V20.3608L70.8892 37.1688L44.8501 24.1562Z"
          fill="#24576B"
        />
        <path
          d="M102.866 16.0361V8.7034H97.7517V10.4992L95.8432 8.43262L83.3661 21.9874L78.4838 25.2405L70.9136 80.5196L82.3303 91.9302H108.863V22.5296L102.866 16.0361Z"
          fill="#E3E3E3"
        />
        <path
          d="M83.3663 21.9873H42.1377V91.9301H83.3663V21.9873Z"
          fill="#FCF9F9"
        />
        <path
          d="M65.7354 74.8511H58.1406V91.9301H65.7354V74.8511Z"
          fill="#E3E3E3"
        />
        <path
          d="M50.0033 79.7307V77.0198H46.7485V79.7307H49.7321H50.0033Z"
          fill="#24576B"
        />
        <path
          d="M49.7321 81.8994H46.7485V84.6104H50.0033V81.8994H49.7321Z"
          fill="#24576B"
        />
        <path
          d="M55.4282 77.0198H52.1733V79.7307H55.4282V77.0198Z"
          fill="#24576B"
        />
        <path
          d="M55.4282 81.8994H52.1733V84.6104H55.4282V81.8994Z"
          fill="#24576B"
        />
        <path
          d="M72.245 79.7307V77.0198H68.9902V79.7307H71.9738H72.245Z"
          fill="#24576B"
        />
        <path
          d="M71.9738 81.8994H68.9902V84.6104H72.245V81.8994H71.9738Z"
          fill="#24576B"
        />
        <path
          d="M77.6699 77.0198H74.415V79.7307H77.6699V77.0198Z"
          fill="#24576B"
        />
        <path
          d="M77.6699 81.8994H74.415V84.6104H77.6699V81.8994Z"
          fill="#24576B"
        />
        <path
          d="M95.0293 25.5114V22.8005H91.7744V25.5114H94.7581H95.0293Z"
          fill="#24576B"
        />
        <path
          d="M94.7581 27.6804H91.7744V30.3913H95.0293V27.6804H94.7581Z"
          fill="#24576B"
        />
        <path
          d="M100.454 22.8005H97.1992V25.5115H100.454V22.8005Z"
          fill="#24576B"
        />
        <path
          d="M100.454 27.6802H97.1992V30.3911H100.454V27.6802Z"
          fill="#24576B"
        />
        <path
          d="M95.0293 40.6929V37.9819H91.7744V40.6929H94.7581H95.0293Z"
          fill="#24576B"
        />
        <path
          d="M94.7581 42.8616H91.7744V45.5725H95.0293V42.8616H94.7581Z"
          fill="#24576B"
        />
        <path
          d="M100.454 37.9819H97.1992V40.6929H100.454V37.9819Z"
          fill="#24576B"
        />
        <path
          d="M100.454 42.8618H97.1992V45.5728H100.454V42.8618Z"
          fill="#24576B"
        />
        <path
          d="M95.0293 55.8746V53.1636H91.7744V55.8746H94.7581H95.0293Z"
          fill="#24576B"
        />
        <path
          d="M94.7581 58.043H91.7744V60.7539H95.0293V58.043H94.7581Z"
          fill="#24576B"
        />
        <path
          d="M100.454 53.1633H97.1992V55.8743H100.454V53.1633Z"
          fill="#24576B"
        />
        <path
          d="M100.454 58.043H97.1992V60.7539H100.454V58.043Z"
          fill="#24576B"
        />
        <path
          d="M95.0293 71.0557V68.3447H91.7744V71.0557H94.7581H95.0293Z"
          fill="#24576B"
        />
        <path
          d="M94.7581 73.2246H91.7744V75.9356H95.0293V73.2246H94.7581Z"
          fill="#24576B"
        />
        <path
          d="M100.454 68.3447H97.1992V71.0557H100.454V68.3447Z"
          fill="#24576B"
        />
        <path
          d="M100.454 73.2246H97.1992V75.9356H100.454V73.2246Z"
          fill="#24576B"
        />
        <path
          d="M78.2125 25.5117H46.7485V32.018H78.2125V25.5117Z"
          fill="#24576B"
        />
        <path
          d="M78.2125 38.5242H46.7485V45.0305H78.2125V38.5242Z"
          fill="#24576B"
        />
        <path
          d="M78.2125 51.5369H46.7485V58.0432H78.2125V51.5369Z"
          fill="#24576B"
        />
        <path
          d="M78.2125 64.5493H46.7485V71.0556H78.2125V64.5493Z"
          fill="#24576B"
        />
        <path d="M151 91.6572H0V91.9227H151V91.6572Z" fill="#3F3D56" />
        <path
          d="M26.0673 61.0068H25.2871V91.8084H26.0673V61.0068Z"
          fill="#3F3D56"
        />
        <path
          d="M33.2676 64.9323C33.3173 75.7028 25.7356 84.4691 25.7356 84.4691C25.7356 84.4691 18.0733 75.773 18.0237 65.0025C17.974 54.2319 25.5557 45.4656 25.5557 45.4656C25.5557 45.4656 33.2179 54.1617 33.2676 64.9323Z"
          fill="#04C2A0"
        />
        <path
          opacity="0.1"
          d="M33.2676 64.9323C33.3173 75.7028 25.7356 84.4691 25.7356 84.4691C25.7356 84.4691 18.0733 75.773 18.0237 65.0025C17.974 54.2319 25.5557 45.4656 25.5557 45.4656C25.5557 45.4656 33.2179 54.1617 33.2676 64.9323Z"
          fill="black"
        />
        <path
          d="M15.9242 61.0068H15.144V91.8084H15.9242V61.0068Z"
          fill="#3F3D56"
        />
        <path
          d="M23.125 64.9323C23.1747 75.7028 15.593 84.4691 15.593 84.4691C15.593 84.4691 7.93076 75.773 7.8811 65.0025C7.83144 54.2319 15.4131 45.4656 15.4131 45.4656C15.4131 45.4656 23.0753 54.1617 23.125 64.9323Z"
          fill="#04C2A0"
        />
        <path
          d="M125.575 21.9436C119.429 21.9719 114.427 22.0627 114.427 22.0627C114.427 22.0627 120.373 14.1906 125.553 17.1071C130.732 20.0237 136.683 21.9602 136.683 21.9602C136.683 21.9602 131.721 21.9153 125.575 21.9436Z"
          fill="#F2F2F2"
        />
        <path
          d="M23.1819 37.0755C17.0361 37.1038 12.0337 37.1945 12.0337 37.1945C12.0337 37.1945 17.9799 29.3224 23.1596 32.239C28.3394 35.1555 34.2896 37.092 34.2896 37.092C34.2896 37.092 29.3278 37.0472 23.1819 37.0755Z"
          fill="#F2F2F2"
        />
        <path
          d="M45.493 5.48464C39.3472 5.51295 34.3447 5.60371 34.3447 5.60371C34.3447 5.60371 40.2909 -2.26843 45.4707 0.648139C50.6504 3.56471 56.6007 5.50119 56.6007 5.50119C56.6007 5.50119 51.6388 5.45633 45.493 5.48464Z"
          fill="#F2F2F2"
        />
        <path
          d="M138.239 61.0068H137.458V91.8084H138.239V61.0068Z"
          fill="#3F3D56"
        />
        <path
          d="M145.439 64.9323C145.489 75.7028 137.907 84.4691 137.907 84.4691C137.907 84.4691 130.245 75.773 130.195 65.0025C130.145 54.2319 137.727 45.4656 137.727 45.4656C137.727 45.4656 145.389 54.1617 145.439 64.9323Z"
          fill="#04C2A0"
        />
        <path
          d="M109.521 72.6894H117.394V70.7898H121.739V72.6894H129.884V81.1018H121.739V91.6851H117.394V81.1018H109.521L105.448 76.4885L109.521 72.6894Z"
          fill="#24576B"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="151" height="92" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
};
